import React from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { appointmentConsentsModalActions } from '../../../../../redux/healthboard/appointment-consent-modal';
import { formatDateByYear } from '../../../../../utils/converters/dateConverters';
import { renderConsentHeader } from '../utils/renderConsentHeader';
import { isCompleted } from '../../../utils';
import styles from './index.styl';

export function ConsentListItem({ entity, formatMessage, onClick }) {
  const titleTypeConsent = formatMessage({
    id: 'appointment.consent.details.type',
  });

  const {
    id,
    completedTime,
    todoStatus,
    userAppointment: {
      organization: { name: organizationName },
      service: { name: serviceName },
      startTime,
      userId,
    },
    consents,
  } = entity;
  const time = isCompleted(todoStatus) ? completedTime : startTime;
  const formatTime = formatDateByYear(time, formatMessage);

  const dispatch = useDispatch();
  const handleOpenConsent = () => {
    return onClick
      ? onClick()
      : dispatch(
          appointmentConsentsModalActions.open({
            consent: consents[0],
            organizationName,
            serviceName,
            startTime,
            allConsents: consents,
            patientUserInfoId: userId,
          }),
        );
  };

  return (
    <div className={styles.root} onClick={handleOpenConsent} key={id}>
      {renderConsentHeader(
        formatMessage,
        titleTypeConsent,
        organizationName,
        serviceName,
        formatTime,
      )}
    </div>
  );
}

ConsentListItem.defaultProps = {
  onClick: null,
};

ConsentListItem.propTypes = {
  entity: PropTypes.object,
  formatMessage: PropTypes.func,
  onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentListItem/index.jsx